import React, { useContext } from "react"
import { ThemeContext } from "."

export const withDarkTheme = Component => props => {
  const { isDark } = useContext(ThemeContext)

  return <Component dark={isDark} {...props} />
}
